<ng-container *ngIf="appointment$ | async as appointment">
  <app-day-view></app-day-view>
</ng-container>
